const theme = {
  media: {
    tablet: '@media ( min-width: 50rem )',
    desktop: '@media ( min-width: 100rem )',
  },
};

export default theme;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/styles/theme.ts